// extracted by mini-css-extract-plugin
export default {"languageSelect":"verification-service-details-container__language-select__g94Dx"};